export default [
  {
    title: 'breadcrumb.betSetting',
    route: 'bet-setting',
    icon: '',
    resource: 'bet-setting',
    action: 'read'
  }
];